import { UserNotificationStatus } from '@touche-lts/panel-ui/dist';
import { makeAutoObservable } from 'mobx';
import RootStore  from 'mobx-stores/root-store'
import { Notifications } from 'models/notifications';
import { Api } from 'services';

export class NotificationsStore {
  private rootStore:any
  private notificationsApi: Api['notificationsApi']

  constructor (rootStore:any) {
    this.rootStore = rootStore;
    this.notificationsApi = this.rootStore.generalStore.api.notificationsApi;
    makeAutoObservable(this);
  }

  // OBSERVABLES
  private notifications: Notifications[] = [];

  // COMPUTED
  public get canbanNotifications(): Notifications[] {
    return this.notifications;
  }

  public get canbanNotificationsNew(): Notifications[] {
    return this.notifications.filter((notification: Notifications) => notification.notificationStatus === UserNotificationStatus.NEW);
  }

  // METHODS
  public getNotifications = async (): Promise<Notifications[]> => {
    const notificationInfo = await this.notificationsApi.getNotificationsByUser()
    if(!notificationInfo) return;
    this.notifications = [];
    this.notifications = JSON.parse(JSON.stringify(notificationInfo));
  }

  public deleteNotification = async (notificationId: number) => {
    await this.notificationsApi.deleteNotification(notificationId)
    this.getNotifications()
  }

}
